import React, { memo } from 'react';
import { Pressable } from 'react-native';

import { Stack } from '@/components/layout';
import { SvgIcon, Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

type Props = {
  label: string;
  onPress: () => void;
};

/** Dashed "Invite another people" CTA shown to the primary guardian. */
function InviteAdultsButton({ label, onPress }: Props) {
  const styles = useStyles();
  const { scale } = useScaling();

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={label}
      onPress={onPress}
      style={({ pressed }) => [styles.button, pressed ? styles.pressed : null]}>
      <Stack align="center" justify="center" style={styles.iconWrap}>
        <SvgIcon name="IcPlusBold" size={scale(20)} color={guardianColors['Main/Main']} />
      </Stack>
      <Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold" style={styles.label}>
        {label}
      </Text>
    </Pressable>
  );
}

export default memo(InviteAdultsButton);

const useStyles = createStyles(({ scale }) => ({
  button: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'stretch',
    gap: scale(8),
    padding: scale(12),
    borderRadius: scale(12),
    borderCurve: 'continuous',
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: guardianColors.Blue,
    backgroundColor: colors['0'],
  },
  pressed: {
    opacity: 0.7,
  },
  iconWrap: {
    width: scale(40),
    height: scale(40),
    borderRadius: scale(20),
    backgroundColor: guardianColors['Main/10'],
  },
  label: {
    color: guardianColors['Main/Main'],
  },
}));
